import { render, staticRenderFns } from "./DemoComp1.vue?vue&type=template&id=b85f681c"
import script from "./DemoComp1.vue?vue&type=script&lang=js"
export * from "./DemoComp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports